export default __webpack_public_path__ + "static/media/logo_txt_crop.856b9390.png";